var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreareOrder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.75C0 4.36704 4.36704 0 9.75 0C15.133 0 19.5 4.36704 19.5 9.75C19.5 15.133 15.133 19.5 9.75 19.5C4.36704 19.5 0 15.133 0 9.75ZM9.75 1.5C5.19546 1.5 1.5 5.19546 1.5 9.75C1.5 14.3045 5.19546 18 9.75 18C14.3045 18 18 14.3045 18 9.75C18 5.19546 14.3045 1.5 9.75 1.5ZM9.75 5.25C10.1642 5.25 10.5 5.58579 10.5 6V9H13.5C13.9142 9 14.25 9.33579 14.25 9.75C14.25 10.1642 13.9142 10.5 13.5 10.5H10.5V13.5C10.5 13.9142 10.1642 14.25 9.75 14.25C9.33579 14.25 9 13.9142 9 13.5V10.5H6C5.58579 10.5 5.25 10.1642 5.25 9.75C5.25 9.33579 5.58579 9 6 9H9V6C9 5.58579 9.33579 5.25 9.75 5.25Z",
    fill: "#E2F7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreareOrder);
export default __webpack_public_path__ + "static/media/creare_order.980b3b4b62849f0d6b19080b7f0a7ada.svg";
export { ForwardRef as ReactComponent };